import { useUIStore } from '@/stores/uiStore';
import { useUserStore } from '@/stores/userStore';
import { useNavigate } from 'react-router-dom';

export const Header = () => {
  const { openInfoModal } = useUIStore();
  const { isRegistered } = useUserStore();
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    // Hidden on mobile (md:flex shows on desktop only)
    <header className="hidden md:flex fixed top-0 left-0 right-0 bg-white/80 backdrop-blur-lg border-b border-cream z-40">
      <div className="container-safe h-16 flex items-center justify-between max-w-7xl mx-auto px-6">
        {/* Logo */}
        <button
          onClick={handleLogoClick}
          className="flex items-center gap-2 group transition-transform hover:scale-105"
        >
          <img src="/hwr-logo2026.png" alt="Greater Heights" className="w-10 h-10 rounded-lg object-cover shadow-soft" />
          <div>
            <h1 className="text-base font-display font-bold text-earth-brown leading-none">
              Greater Heights
            </h1>
            <p className="text-xs text-earth-brown/60">Holy Week Retreat 2026</p>
          </div>
        </button>

        {/* Actions */}
        {isRegistered && (
          <button
            onClick={openInfoModal}
            className="p-2 rounded-lg hover:bg-cream transition-colors"
            aria-label="Event information"
          >
            <svg
              className="w-6 h-6 text-earth-brown"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </button>
        )}
      </div>
    </header>
  );
};